<script setup>
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import useApprovalFlow from "@/composables/approval-center/useApprovalFlow";
import KitFeedbackModal from "@/components/global-themed/modals/KitFeedbackModal.vue";

const feedbackValue = defineModel({
  type: String,
  required: true,
});

const {revisionErrors: errors} = useApprovalFlow();

const emit = defineEmits(['close', 'confirm', 'extra-help']);
</script>

<template>
  <KitFeedbackModal
    v-model="feedbackValue"
    :errors="errors"
    kit-icon-state="error"
    @close="emit('close')"
    @confirm="emit('confirm')"
  >
    <template #header>
      <ModalHeader>
        <ModalHeading>Let me fix that for you!</ModalHeading>

        <ModalSubText>
          Tell me what you’d like me to change or improve in the content. The more specific you can be, the better I can refine and personalize it for your business. Once you’ve provided your feedback below, click <span class="tw-font-bold">Continue</span> and I’ll get straight to work!
        </ModalSubText>
      </ModalHeader>
    </template>
  </KitFeedbackModal>
</template>
